import React from 'react';
import { X } from 'lucide-react';
import { Button } from './ui/button';
import { useLanguage } from '../hooks/useLanguage';

const LanguagePrompt = () => {
  const { showLanguagePrompt, dismissLanguagePrompt } = useLanguage();

  if (!showLanguagePrompt) return null;

  return (
    <div 
      className="fixed inset-0 z-[100] flex items-center justify-center bg-black/50 backdrop-blur-sm"
      data-testid="language-prompt-overlay"
    >
      <div 
        className="bg-white rounded-lg shadow-2xl max-w-md mx-4 p-6 md:p-8 relative animate-in fade-in zoom-in-95 duration-300"
        data-testid="language-prompt-modal"
      >
        {/* Close button */}
        <button
          onClick={() => dismissLanguagePrompt('en')}
          className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 transition-colors"
          data-testid="language-prompt-close"
          aria-label="Close"
        >
          <X className="w-5 h-5" />
        </button>

        {/* Content */}
        <div className="text-center">
          {/* Icon/Badge */}
          <div className="w-16 h-16 mx-auto mb-4 bg-[#1F2A44] rounded-full flex items-center justify-center">
            <span className="text-2xl">🌐</span>
          </div>

          {/* Title */}
          <h2 className="text-2xl font-serif text-[#1F2A44] mb-2">
            ¿Hablas Español?
          </h2>
          <p className="text-[#555555] mb-6 text-sm">
            We detected your browser is set to Spanish. Would you like to view this site in Spanish?
          </p>
          <p className="text-[#555555] mb-6 text-sm italic">
            Detectamos que tu navegador está en español. ¿Te gustaría ver este sitio en español?
          </p>

          {/* Buttons */}
          <div className="flex flex-col sm:flex-row gap-3">
            <Button
              onClick={() => dismissLanguagePrompt('es')}
              className="flex-1 bg-[#C2A46D] hover:bg-[#A88B55] text-[#1F2A44] py-3 rounded-md text-sm font-semibold"
              data-testid="language-prompt-spanish"
            >
              Sí, ver en Español
            </Button>
            <Button
              onClick={() => dismissLanguagePrompt('en')}
              variant="outline"
              className="flex-1 border-[#1F2A44] text-[#1F2A44] hover:bg-[#1F2A44] hover:text-white py-3 rounded-md text-sm font-medium"
              data-testid="language-prompt-english"
            >
              No, keep English
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LanguagePrompt;
